module.exports = __webpack_public_path__ + "media/packs/images/flags/JO-7161e3e25a9a91600318b3442875e1b4.png";